<template>
  <Table :heads="heads" :rows="rows">
    <template v-slot:caption>
      <Heading tag="h2" font-size="26px">{{ $t('product.prices_on') }} {{ category_name }}:</Heading>
    </template>
  </Table>
</template>

<script setup>
import { computed } from 'vue';
import Table from "~/components/molecules/Table.vue";
import Heading from "~/components/atoms/Heading.vue";
import { useCartStore } from "~/store/cartStore.js";
const {t} = useI18n();

const props = defineProps({
  items: {
    type: Array,
    required: true
  },
  category_name: {
    type: String,
    required: true
  }
});

const store = useCartStore();

const heads = computed(() => [
  { title: props.category_name },
  { title: t('product.price') },
  { title: t('product.order') }
]);

const rows = computed(() => props.items.map(product => [
  { content: product.name, type: 'link', url: `${product.url}/` },
  { content: `${product.price}/${product.unit}` },
  {
    content: 'KÖP',
    type: 'button',
    callback: () => {
      store.addItemToCart({
        id: product.id,
        count: 1,
        source: store.sources.product_category_faq
      });
    }
  }
]));
</script>

<style scoped>

</style>
